// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1mtoB","resendInfoText":"OnGoingPaymentBox_resendInfoText__1rwmy"};